// Class: motion.easing.Quad

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function motion_easing__$Quad_QuadEaseIn() {return require("./../../motion/easing/_Quad/QuadEaseIn");}
function motion_easing__$Quad_QuadEaseInOut() {return require("./../../motion/easing/_Quad/QuadEaseInOut");}
function motion_easing__$Quad_QuadEaseOut() {return require("./../../motion/easing/_Quad/QuadEaseOut");}

// Constructor

var Quad = function(){}

// Meta

Quad.__name__ = ["motion","easing","Quad"];
Quad.__isInterface__ = false;
Quad.prototype = {
	
};
Quad.prototype.__class__ = Quad.prototype.constructor = $hxClasses["motion.easing.Quad"] = Quad;

// Init



// Statics


Quad.easeIn = new (motion_easing__$Quad_QuadEaseIn().default)()
Quad.easeInOut = new (motion_easing__$Quad_QuadEaseInOut().default)()
Quad.easeOut = new (motion_easing__$Quad_QuadEaseOut().default)()

// Export

exports.default = Quad;